module.exports = __webpack_public_path__ + "static/marketplace-3f7604f7e01fd4dbde04ddb0f33f8924.png";